<template src="../../templates/dhs/searchDhsBookings.html"></template>

<script>
import UserRoleCollection from '@/collections/userRoleCollection'
import JobsCollection from '@/collections/jobsCollection'
import UserRoleModel from '@/models/userRoleModel'
import JobsModel from '@/components/dhs/JobsModel'
import InvoiceModel from '@/components/dhs/invoiceModel'
import FileView from '@/components/dhs/fileView'
import JwPagination from 'jw-vue-pagination'
import moment from 'moment'
import PopUp from '@/components/dhs/popUp'
import InterpreterDetails from '@/components/dhs/interpreterDetails'
import Config from '../../config/config'
import TimePicker from "../TimePickerCompomponent";

export default {
  name: 'SearchDhsBookingsComponent',
  components: {
    JobsModel, PopUp, InvoiceModel, FileView, InterpreterDetails, TimePicker
  },
  props: ['records'],
  watch: {
    'isInterval': function () {
      let thisComp = this;
      this.intervalVar.push(setInterval(function () {
        // console.log('interval triggered');
        // console.log(thisComp.intervalVar);
        // thisComp.updateJobStatus(thisComp.jobsData);
      }, 10000));
    },
    filtering: {
      handler: function (after, before) {
        if (after === '') {
          this.filteringStyle = 'ag_btn_clear_light ag_cursor_disabled';

          console.log('this.records');
          console.log(this.records);

          if (this.records == "invoice") {
            this.filteredJobs = this.jobsCollection.models;
          } else if (moment(this.dateSelected).format('DD-MM-YYYY') == moment().format('DD-MM-YYYY')) {
            this.getJobList();
          } else {
            let getJobsForDate = moment(this.dateSelected).format('DD-MM-YYYY');
            this.getSessionDate(getJobsForDate);
          }
        } else {

          console.log('this.jobsCollection.models');
          console.log(this.jobsCollection.models[0]);

          this.filteringStyle = 'ag_btn_clear';
          this.filteredJobs = this.jobsCollection.models.filter(model =>
            (this.records != "invoice" ? (model.job_id != undefined ? model.job_id.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.ref_num != undefined ? model.ref_num.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.service_centre != undefined ? model.service_centre.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.zone != undefined ? model.zone.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.interpreterType != undefined ? model.interpreterType.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.NaatiLevel != undefined ? model.NaatiLevel.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.serviceTimeRange != undefined ? model.serviceTimeRange.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records != "invoice" ? (model.int_id != undefined ? model.int_id.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records != "invoice" ? (model.location != undefined ? model.location.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (model.service_date != undefined ? model.service_date.toLowerCase().includes(after.toLowerCase()) : "") ||
            (this.records != "invoice" ? (model.state != undefined ? model.state.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records != "invoice" ? (model.interpreter != undefined ? model.interpreter.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.interpreter_name != undefined ? model.interpreter_name.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records != "invoice" ? (model.language != undefined ? model.language.toLowerCase().includes(after.toLowerCase()) : "") : "") ||
            (this.records == "invoice" ? (model.sessionLangs != undefined ? model.sessionLangs.toLowerCase().includes(after.toLowerCase()) : "") : "")
          )
        }
      },
      deep: true
    },
    currentRole: {
      handler: function (after) {

        if (after[0] != undefined && this.reloadingPage === true) {
          localStorage.setItem('role_id', after[0].role_id);
        } else localStorage.setItem('role_id', after.role_id);

        this.reloadingPage = false;
        this.showCustomRecords = false;

        if (this.records != 'current') this.getRecords(this.records);
        else this.getJobList();
      },
      deep: true
    },
    dateSelected: {
      handler: function (after) {
        let getJobsForDate = moment(after).format('DD-MM-YYYY');
        this.invoiceNumber = 0;
        this.jobNumber = 0;
        this.dateRangePicked = '';
        this.showCustomRecords = false;
        this.getSessionDate(getJobsForDate);
      },
      deep: true
    },
    selectedPageSize: {
      handler: function () {

        this.componentKey += 1 //This is used to re-render the component of page size selection
      },
      deep: true
    },
    '$route': 'initialiseComponent'
  },
  data() {
    return {
      tempJobsCollection: [],
      selectedComponent: JwPagination,
      userRoleCollection: new UserRoleCollection(),
      jobsCollection: new JobsCollection(),
      userRoleModel: new UserRoleModel(),
      isResize: false,
      isToggleable: 'sm',
      filteringStyle: 'ag_btn_clear_light ag_cursor_disabled',
      filtering: null,
      intervalVar: [],
      isInterval: false,
      currentRole: [],
      reloadingPage: false,
      viewLegends: false,
      tableHeader: [],
      recordsByDateRange: [
        {
          key: 'location',
          label: 'Location',
          sortable: true,
          thStyle: {
            border: '2px solid white',
            width: '305px'
          }
        },
        {
          key: 'service_date',
          label: 'Date',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'job_id',
          label: 'Job Num',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'state',
          label: 'State',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'int_id',
          label: 'INT ID',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'interpreter',
          label: 'Interpreter',
          sortable: true,
          thStyle: {
            border: '2px solid white',
            width: '200px'
          }
        },
        {
          key: 'language',
          label: 'Language',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'service_time',
          label: 'Service Time',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'requested_time',
          label: 'Requested Time',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'vic_time',
          label: 'VIC Time',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'is_logged_in',
          label: 'Logged in',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'clocking_status',
          label: 'Clocked On/Off',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'on_break_status',
          label: 'On Break',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        }
      ],
      recordsByInvoiceNumber: [
        {
          key: 'zone',
          label: 'Zone',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'service_centre',
          label: 'Service Centre',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'ref_num',
          label: 'Job Num',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'sessionLangs',
          label: 'Language',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'interpreter_name',
          label: 'Interpreter',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'interpreterType',
          label: 'Type',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'NaatiLevel',
          label: 'Naati Level',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'service_date',
          label: 'Date',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'serviceTimeRange',
          label: 'Time',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'booked_charge',
          label: 'Book Charge',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'actual_charge',
          label: 'Actual Charge',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'variationCharge',
          label: 'Variation Charge',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'travel_cost',
          label: 'Travel Cost',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'gst',
          label: 'GST',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        },
        {
          key: 'incGst',
          label: 'INC GST',
          sortable: true,
          thStyle: {
            border: '2px solid white'
          }
        }
      ],
      sortStatuses: {
        location: "none",
        service_date: "none",
        job_id: "asc",
        state: "none",
        int_id: "none",
        interpreter: "none",
        service_time: "none",
        vic_time: "none",
        is_logged_in: "none",
        clocking_status: "none",
        on_break_status: "none",
        zone: "asc",
        service_centre: "none",
        ref_num: "none",
        sessionLangs: "none",
        interpreter_name: "none",
        NaatiLevel: "none",
        serviceTimeRange: "none",
        booked_charge: "none",
        actual_charge: "none",
        variationCharge: "none",
        travel_cost: "none",
        gst: "none",
        incGst: "none",
      },
      sortBy: 'location',
      sortDesc: false,
      rowObject: {
        "overflow-y": "scroll",
        height: this.getScrollableHeight(),
        "max-height": this.getScrollableHeight()
      },
      dateSelected: '',
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      currentViewPage: 1,
      isDataLoading: false,
      selectedPageSize: 100,
      pageOptions: [10, 25, 50, 100],
      paginatedJobCollections: [],
      componentKey: 0,
      customStyles: {
        ul: {
          'border-radius': '20px',
          'margin-top': '3px'
        },
        a: {
          color: '#F08532',
          padding: '3px 15px'
        }
      },
      viewRecordsModal: false,
      type: '',
      recordsTitle: '',
      invoiceNumber: 0,
      jobNumber: 0,
      dateRangePicked: '',
      showInvoiceRecords: false,
      showJobsRecords: false,
      showCustomRecords: false,
      viewInvoiceModal: false,
      viewIntDetailsModal: false,
      jobID: 0,
      pageTitle: '',
      viewActivityList: false,
      viewActivityDeleteModal: false,
      viewActivityEditModal: false,
      showTimeEndInput: false,
      activityJobId: 0,
      activityContent: '',
      activity_id: 0,
      activity_type_id: 0,
      dynamicActivityContent: null,
      interpreterActivities: [],
      activityLabelText: '',
      activityTimeStartPicked: '00:00:00',
      activityTimeEndPicked: '00:00:00',
      currentState: '',
      filteredJobs: [],
      currentSort: 'name',
      currentSortDir: 'asc',
      hidePopUpOnClose: false
    }
  },
  created() {
    this.initialiseComponent();
  },
  mounted() {

    let resizeId;
    let thisComponent = this;
    window.addEventListener('resize', function () {
      clearTimeout(resizeId);
      resizeId = setTimeout(thisComponent.doneResizing, 500);
    });

    Event.$on('hidePopUp', () => {
      this.jobID = 0;
      if (this.showJobsRecords) this.$router.push({path: '/SearchDhsBooking/current'});
      else this.closePopUps();
    });

    Event.$on('hideFileView', () => {
      this.closePopUps();
    });

    Event.$on('viewInvoiceDetails', (jobID) => {
      this.viewInvoiceModal = true;
      this.hidePopUpOnClose = true;
      this.jobID = jobID;
    });

    Event.$on('viewActivityList', (activities, job_id, currentState) => {
      this.viewActivityList = true;
      this.interpreterActivities = activities;
      this.activityJobId = job_id;
      this.currentState = currentState;
    });

    Event.$on('getRecords', (dtRange, sltdRole, invNumber, jobNumber) => {
      this.showCustomRecords = true;

      if (invNumber) {
        this.showInvoiceRecords = true;
        this.showJobsRecords = false;
        this.invoiceNumber = invNumber;
        this.jobNumber = jobNumber;
        this.dateRangePicked = '';
        this.recordsTitle = 'invoice number';
        this.pageTitle = '';
        // this.pageTitle = 'invoice';
        this.tableHeader = this.recordsByInvoiceNumber;

        let url = this.jobsCollection.setRoleID(localStorage.getItem('role_id')) + '?invoice=' +
          this.invoiceNumber + '&jobNum=' + this.jobNumber;
        this.getJobs(url);
      } else if (jobNumber) {
        this.viewInvoiceModal = true;
        this.hidePopUpOnClose = false;
        this.jobID = jobNumber;
      } else {
        this.showInvoiceRecords = false;
        this.showJobsRecords = true;
        this.invoiceNumber = 0;
        this.jobNumber = 0;
        this.recordsTitle = 'date';
        this.pageTitle = this.type == 'relief' ? 'Relief Interpreter jobs' : 'Unfilled jobs';
        this.tableHeader = this.recordsByDateRange;
        this.dateRangePicked = moment(dtRange[0]).format('DD MMM YYYY') + ' to ' + moment(dtRange[1]).format('DD MMM YYYY');

        let url = this.jobsCollection.getJobRecordsFor(this.type) +
          '?roleID=' + localStorage.getItem('role_id') +
          '&startDate=' + moment(dtRange[0]).format('DD-MM-YYYY') +
          '&endDate=' + moment(dtRange[1]).format('DD-MM-YYYY');
        this.getJobs(url);
      }

      this.viewRecordsModal = false;
    });

    this.sockets.subscribe("activity-status-message", (wsMessage) => {
      Event.$emit('jobsModelActivities', wsMessage);
    });
  },
  unmounted() {
    this.sockets.unsubscribe("activity-status-message");
  },
  destroyed() {
    this.sockets.unsubscribe("activity-status-message");
  },
  beforeDestroy() {
    this.clearIntervals();
    this.closeConnection();
    Event.$off('disableEventTrigger');
  },
  methods: {
    refreshPage() {
      this.viewRecordsModal = true;
    },
    initialiseComponent() {
      if (this.records == 'current') {
        this.defaultSettings();

        if (localStorage.getItem("pageSize") != null && localStorage.getItem("pageSize") != 7) {
          this.selectedPageSize = parseInt(localStorage.getItem("pageSize"));
        } else {
          localStorage.setItem("pageSize", this.selectedPageSize.toString());
        }
      }

      this.getRoles();
    },
    closePopUps() {
      this.viewInvoiceModal = false;

      if (this.jobID > 0 && !this.hidePopUpOnClose) this.viewRecordsModal = true;
      else this.viewRecordsModal = false;

      this.hidePopUpOnClose = false;
    },
    closeConnection() {
      io.disconnect();
    },
    defaultSettings() {
      this.tableHeader = [];
      this.showInvoiceRecords = false;
      this.showCustomRecords = false;
      this.showJobsRecords = true;
      this.isInterval = true;
      this.reloadingPage = true;
      this.recordsTitle = 'date';
      this.pageTitle = '';
      this.dateSelected = this.dateSelected === '' ? Date.now() : this.dateSelected;
      this.tableHeader = this.recordsByDateRange;
    },
    doneResizing() {
      this.isResize = true;

      if (this.$browserDetect.isSafari) {
        setTimeout(function () {
          window.location.reload();
        }, 500);
        return;
      }

      this.$router.go(0);
    },
    getRoles() {
      this.userRoleCollection.fetch(
        {
          'url': this.userRoleCollection.getRoute('fetch'),
        }
      ).then(() => {
        this.getDefaultRole();

      }).catch((error) => {
        console.error(error);
      });
    },
    getDefaultRole() {
      this.userRoleModel.fetch(
        {
          'url': this.userRoleModel.getRoute('fetch'),
        }
      ).then(() => {
        this.currentRole = [];
        let role_id = localStorage.getItem('role_id');

        if (role_id == null || role_id == 0 || role_id == 'undefined') {
          this.currentRole.push(this.userRoleModel.attributes.data);
          localStorage.setItem('role_id', this.userRoleModel.attributes.data.role_id);
        } else {
          let thisComp = this;
          this.userRoleCollection.models.forEach(model => {
            if (role_id == model.attributes.role_id) {
              thisComp.currentRole.push(model.attributes);
            }
          })
        }

      }).catch((error) => {
        console.error(error);
      });
    },
    getJobList() {
      this.defaultSettings();
      let url = this.$publicApiURL + this.jobsCollection.getRoute('getDhsJobs') + '?roleID=' + localStorage.getItem('role_id');
      this.getJobs(url);
    },
    getSessionDate(getJobsForDate) {
      this.defaultSettings();
      let url = this.$publicApiURL + this.jobsCollection.getRoute('getDhsJobsByDate') + '?roleID=' + localStorage.getItem('role_id') + '&selectedDate=' + getJobsForDate;
      this.getJobs(url);
    },
    getJobs(url) {
      Event.$emit('disableEventTrigger', true);
      this.isDataLoading = true;
      this.jobsCollection.models = [];
      this.$http.get(url, {
        headers: {"Bearer": localStorage.getItem("jwt")}
      }).then((res) => {
        let jobsCollections = res.data.data;
        if (jobsCollections != undefined) {
          this.jobsCollection.models = this.filteredJobs = jobsCollections;
          this.isDataLoading = false;
          Event.$emit('disableEventTrigger', false);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    clearIntervals() {
      for (let intervalID of this.intervalVar) {
        clearInterval(intervalID);
      }

      this.intervalVar = [];
      this.isInterval = !this.isInterval;
    },
    getScrollableHeight() {
      console.log('window.innerHeight');
      console.log(window.innerHeight);
      let offset = 0;
      if (window.innerHeight > 900) {
        offset = 240;
      } else if (800 < window.innerHeight < 900) {
        offset = 260;
      } else if (700 < window.innerHeight < 800) {
        offset = 280;
      } else if (600 < window.innerHeight < 700) {
        offset = 290;
      }

      return window.innerHeight - offset + "px";
    },
    handleSizeChange(val) {
      console.log(`${val} items per page`);
      localStorage.setItem("pageSize", val);
      this.selectedPageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`current page: ${val}`);
    },
    onChangePage(pageOfItems) {
      console.log('pageOfItems');
      console.log(pageOfItems);
      this.paginatedJobCollections = pageOfItems;
    },
    getRecords(type) {
      this.viewRecordsModal = true;
      this.type = type;
    },
    showLegends() {
      this.viewLegends = true;
    },
    showDeleteActivity(activityID) {
      this.viewActivityDeleteModal = true;
      this.activity_id = activityID;
    },
    showEditActivity(activityID, activityTypeID, jobID) {
      this.activity_id = activityID;
      this.activity_type_id = activityTypeID;
      this.activityJobId = jobID;
      this.viewActivityEditModal = true;
      this.activityTimeStartPicked = '00:00:00';
      this.activityTimeEndPicked = '00:00:00';
      this.activityLabelText = 'Activity Time Start';
      this.activityLabelTextEndTime = 'Activity Time End';

      if (this.activity_type_id == 9 || this.activity_type_id == 10) {
        this.activityLabelText = 'Activity Time';
        this.showTimeEndInput = false;
      } else this.showTimeEndInput = true;
    },
    updateActivity() {
      if (this.activity_type_id == 9) //clock on
        this.resetClockOn();
      else if (this.activity_type_id == 10) //clock off
        this.resetClockOff();
      else //lunch activity
        this.resetLunchActivity();
    },
    resetClockOn() {
      this.defaultClockOnOffReset('resetclockon', 'clockon');
    },
    resetClockOff() {
      this.defaultClockOnOffReset('resetclockoff', 'clockoff');
    },
    defaultClockOnOffReset(resetApiCall, activityType) {
      this.activityTimeEndPicked = 0;

      if (this.activityTimeStartPicked == '') {
        this.$notify({
          title: 'Warning',
          message: 'Activity Time is required.',
          type: 'warning'
        });
        return;
      }

      let url = Config.publicApiURL + 'interpreter/' + resetApiCall + '?token=' + localStorage.getItem("jwt");

      this.$http.post(url, {
        activityID: this.activity_id,
        activityTimeStart: this.activityTimeStartPicked + ':00',
        activityTimeEnd: this.activityTimeEndPicked,
        jobID: this.activityJobId,
        token: localStorage.getItem("jwt")
      }).then((res) => {
        if (res.data.error == false) {
          this.viewActivityDeleteModal = false;
          this.viewActivityList = false;
          this.viewActivityEditModal = false;

          this.$notify({
            title: 'Success',
            message: 'Success. Reset successful for ' + activityType + '.',
            type: 'success'
          });
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    resetLunchActivity() {

      if (this.activityTimeStartPicked == '' || this.activityTimeEndPicked == '') {
        this.$notify({
          title: 'Warning',
          message: 'Activity Time Start & End are required.',
          type: 'warning'
        });
      } else {
        //validate time if valid
        let activityTimeStartSeconds = this.convertTime2Secs(this.activityTimeStartPicked);
        let activityTimeEndSeconds = (this.activityTimeEndPicked == '') ? 0 : this.convertTime2Secs(this.activityTimeEndPicked);

        if (activityTimeEndSeconds > 0 && activityTimeStartSeconds >= activityTimeEndSeconds) {
          this.$notify({
            title: 'Warning',
            message: 'Invalid time, start time is greater/equal than end time.',
            type: 'warning'
          });
          return;
        }
      }

      let url = Config.publicApiURL + 'interpreter/resetlunchactivity?token=' + localStorage.getItem("jwt");

      this.$http.post(url, {
        activityID: this.activity_id,
        activityTimeStart: this.activityTimeStartPicked + ':00',
        activityTimeEnd: this.activityTimeEndPicked + ':00',
        jobID: this.activityJobId,
        state: this.currentState,
        token: localStorage.getItem("jwt")
      }).then((res) => {
        if (res.data.error == false) {
          this.viewActivityDeleteModal = false;
          this.viewActivityList = false;
          this.viewActivityEditModal = false;

          this.$notify({
            title: 'Success',
            message: 'Success. Reset successful for lunch activity.',
            type: 'success'
          });
        }

      }).catch(function (error) {
        console.log(error);
      });
    },
    convertTime2Secs(arg) {

      let result = 0,
        arr = arg.split(':');

      if (parseInt(arr[0]) < 12) {
        result = parseInt(arr[0]) * 3600 // hours
      }

      let minutes = arr[1].split(" ");
      result += parseInt(minutes[0]) * 60; // minutes

      if (arg.indexOf('P') > -1) {  // 8:00 PM > 8:00 AM
        result += 43200
      }
      return result

    },
    deleteActivity() {
      let url = Config.publicApiURL + 'interpreter/deleteactivity?token=' + localStorage.getItem("jwt");

      this.$http.post(url, {
        activityID: this.activity_id,
        token: localStorage.getItem("jwt")
      });

      this.viewActivityDeleteModal = false;
      this.viewActivityList = false;

      this.$notify({
        title: 'Success',
        message: 'Activity successfully deleted!',
        type: 'success'
      });
    },
    sortTable(event, sortKey) {

      let clickedButtonId = event.currentTarget.id;
      let sortKeys = Object.keys(this.sortStatuses);

      for (let index in sortKeys) {
        if (sortKeys[index] !== clickedButtonId) {
          this.sortStatuses[sortKeys[index]] = "none";
        }
      }
      let currentSortStatus = this.sortStatuses[clickedButtonId];
      if (currentSortStatus === "none") {
        this.sortStatuses[clickedButtonId] = "desc";
      } else if (currentSortStatus === "asc") {
        this.sortStatuses[clickedButtonId] = "desc";
      } else {
        this.sortStatuses[clickedButtonId] = "asc";
      }

      if (sortKey === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }

      this.currentSort = sortKey;

      this.sortedPaginatedJobCollections();
    },
    sortedPaginatedJobCollections() {
      this.paginatedJobCollections.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return modifier;
        return 0;
      });
    },
    isChevronVisible(sortKey) {
      switch (sortKey) {
        case 'service_time':
          return false;
        case 'requested_time':
          return false;
        case 'vic_time':
          return false;
        case 'is_logged_in':
          return false;
        case 'clocking_status':
          return false;
        case 'on_break_status':
          return false;
        case 'serviceTimeRange':
          return false;
        default:
          return true;
      }
    }
  }
}
</script>

<style scoped>
.ag_dropdown_custom >>> .dropdown-menu-right {
  max-width: 8rem !important;
  min-width: auto !important;
}

.ag_dropdown_custom >>> .dropdown-item {
  max-width: 7.8rem !important;
}

.ag_change_role >>> .nav-link {
  color: rgb(255, 255, 255);
  border-left: 1px solid rgba(240, 239, 240, 0.56);
  height: 40px !important;
}

.ag_change_role >>> div {
  margin-top: -2px;
}

.ag_date_picker >>> .nav-link {
  color: rgb(255, 255, 255);
  border-left: 1px solid rgba(240, 239, 240, 0.56);
  height: 40px !important;
}

.ag_date_picker >>> .el-input__inner {
  height: 30px !important;
  border-radius: 5px !important;
  width: 125px !important;
  padding-right: 2px !important;
}

.ag_date_picker >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: fit-content;
  margin-top: -7px !important;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.ag_change_role >>> .multiselect__tags {
  min-height: 28px !important;
  height: 0 !important;
  padding: 0 40px 0 8px !important;
}

.ag_change_role >>> .multiselect__select {
  height: 28px !important;
}

.ag_dropdown_custom >>> .dropdown-toggle {
  /* Don't delete this. This is overwriting default */
  color: rgb(255, 255, 255) !important;
}

.ag_dropdown >>> .dropdown-toggle {
  /* Don't delete this. This is overwriting default */
  color: rgb(255, 255, 255) !important;
}

.ag_dhs_pagination >>> .btn-prev {
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

.ag_dhs_pagination >>> .btn-next {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
}

.ag_show_entries >>> .el-pagination {
  width: 121px !important;
  float: left !important;
}

.ag_show_entries >>> .el-input__inner {
  height: 25px !important;
  border-radius: 12px !important;
}

.ag_show_entries >>> .el-pagination__sizes {
  margin: 0 !important;
}

.ag_dhs_pagination >>> .page-item.active .page-link {
  background-color: #2c3e50 !important;
  border: none !important;
  border-bottom: 2px solid #F08532 !important;
  color: white !important;
}

.ag_dhs_pagination >>> .first a {
  border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
}

.ag_dhs_pagination >>> .last a {
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}

.ag_dhs_pagination >>> .disabled a {
  background-color: #ffffffbf !important;
  border-color: #ffffffbf !important;
  color: #f08532a1 !important;
  cursor: not-allowed !important;
  pointer-events: unset !important;
}

.activityTable >>> td {
  padding: 2px !important;
}

</style>

<style lang="scss" scoped>

@import '../../assets/scss/general.scss';

.scrollable {
  $bodyHeader: 20px;
  $filterOption: 63px;
  $tableHeader-margin: 25px;
  $tableHeader: 58px;
  $pagination: 50px;
  $pagination: 50px;
  $bottomGap: 20px;

  /*
    Use Interpolation
    #{$bodyTopMargin}
  */
  $total: calc(#{$navHeader} +
  #{$bodyTopMargin} +
  #{$bodyHeader} +
  #{$filterOption} +
  #{$tableHeader-margin} +
  #{$tableHeader} +
  #{$pagination} +
  #{$bottomGap} +
  #{$footer});

  height: calc(100vh - #{$total});
  overflow-y: auto;
  background: #fff;
}

.myPagination-group {

  > div {
    padding: 1px 5px;
    color: $myColor-gray-text;

    b {
      color: $myColor-primary;
    }
  }

  .el-input__inner {
    height: 35px !important;
  }

  .myPagination {

    /* Font*/
    li {
      padding-top: 3px;
      font-size: 16px;
      font-weight: normal;
    }

    /* Element Size and the Border */
    li, button {
      margin: 0 !important;
      border: 1px solid $myColor-blue-header;
      border-radius: 0 !important;
      width: 45px !important;
      height: 35px !important;
      align-items: center;

      &:not(:disabled):hover {
        background: rgba($myColor-primary, .8) !important;
        color: #fff !important;
      }

      &:not(:disabled).active {
        background: $myColor-primary !important;
        color: #fff;
        border-bottom: 3px solid $myColor-secondary;
      }
    }
  }
}

// *** PAGINATION


</style>



// WEBPACK FOOTER //
// src/components/dhs/SearchDhsBookingsComponent.vue